import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// @mui imports
import Stack from '@mui/material/Stack'
import ApartmentIcon from '@mui/icons-material/Apartment'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import Typography from '@mui/material/Typography'

// KN imports
import { CompanyType } from 'context/authentication/Company.types'
import { KNCrownIcon } from 'components/KNIcon/KNMaterialIcon'

interface CompanyTypeLabelProps {
  type: CompanyType
  compact?: boolean
}

const getTypeIcon = (type: CompanyType): any => {
  switch (type) {
    case 'Operator':
      return KNCrownIcon
    case 'Carrier':
      return LocalShippingIcon
    case 'Customer':
    default:
      return ApartmentIcon
  }
}

const CompanyTypeLabel = ({ type, compact }: CompanyTypeLabelProps): ReactElement => {
  const { t } = useTranslation()
  const TypeIcon = getTypeIcon(type)
  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <TypeIcon sx={{ color: 'primary.light', fontSize: '1rem' }} />
      {!compact && (
        <Typography variant="p6" color="primary.main">
          {t(`screens.shared.company_manager.company_types.${type}`)}
        </Typography>
      )}
    </Stack>
  )
}

export default CompanyTypeLabel
